export interface UnitsProps {
  count: number | null | undefined;
}

export function Units({ count }: UnitsProps) {
  const n = typeof count === 'number' && Number.isFinite(count) ? count : 0;
  return (
    <span className="ds-num">
      {n.toLocaleString('en-GB')}
      <span className="ds-muted" style={{ marginLeft: 3 }}>
        u
      </span>
    </span>
  );
}

export default Units;
